import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import { CaseHistoryService } from "../../../pages/CaseHistory/CaseHistory.service";
import { loggedInUserService } from "../../../services/loggedInUser.service";
import { utilService } from "../../../services/utilService";
import "./CaseHistoryDetailsEditModal.scss";
import { useToast } from "@agney/ir-toast";
import { PatientFormService } from "../../../pages/PatientForm/PatientForm.service";
import { notesContainerService } from "../../../pages/CaseHistory/EmsNotesContainer/EmsNotesContainer.service";
import { EpicPatientDetailsForm } from "../EpicPatientDetailsForm/EpicPatientDetailsForm";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showPatientAlert: boolean;
  showAlert: () => void;
  caseDetails?: any;
  updateCaseDetailsPage?: any;
  listData: any;
  fetchedcaseHistoryData: any;
}
const CaseHistoryDetailsEditMedia: React.FC<ContainerProps> = (props: any) => {
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [isEMTUser, checkEMTUser]: any = useState(false);
  const [EMTTypes, getEMTTypes] = useState([]);
  const [selectedTypeName, setSelectedTypeName]: any = useState();
  const [MRN, setMRN] = useState(props.caseDetails.mrn);
  const [selectedProvidersNames, setSelectedProvidersNames] = useState([]);
  const [selectedCaseTypeList, setSelectedCaseTypeList]: any = useState([]);
  const [fetchedPatientData, setFetchedPatientData] = useState<any>();
  const [caseTypes, setCaseTypes] = useState<any[]>([]);
  const { t } = useTranslation("emergency");

  const Toast = useToast();

  useEffect(() => {
    displayPatientAlert();
  }, []);

  useEffect(() => {
    if (props.caseDetails.caseTypeId === 0) {
      UpdateSelectedType(props.caseDetails?.caseTypeId);
      setSelectedTypeName(props.caseDetails?.other_case_type_name);
    } else {
      UpdateSelectedType(props.caseDetails?.caseTypeId);
    }
  }, [props.caseDetails?.caseTypeId]);

  useEffect(() => {
    if (props.listData.patientCaseTypes) {
      let caseTypeNames = props.listData.patientCaseTypes.map((item: any) => {
        if (item.is_selected === true&&item?.id===0) {
          return item.type;
        }else if(item.is_selected === true&&item?.id!==0){
          return item.case;
        }
      });

      let caseTypeIds = props.listData.patientCaseTypes.map((item: any) => {
        if (item.is_selected === true) {
          return item.id;
        }
      });

      let caseNameLists = caseTypeNames.filter(function (element: any) {
        return element !== undefined;
      });

      let caseLists = caseTypeIds.filter(function (element: any) {
        return element !== undefined;
      });
      setSelectedCaseTypeList(caseLists);
      setSelectedProvidersNames(caseNameLists);
      checkOtherCaseTypeSelected(caseLists);
    }
  }, [props.listData.patientCaseTypes]);

  let params = {
    reg_code: `${utilService.getNetwork()}`,
  };

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      let isEmtUser = checkIsEMTUser(data?.userData);
      checkEMTUser(isEmtUser);
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (props.caseDetails.display_name) {
      splitUserDisplayName();
    }
  }, [props.caseDetails.display_name]);

  const getTypesList = async () => {
    const getTypesList: any = await PatientFormService.getTypesList(params);
    if (getTypesList.isSuccess) {
      getEMTTypes(getTypesList.result);
    } else {
    }
  };

  const UpdateSelectedType = (selectedType: any) => {
    if (selectedType === 0) {
      // enableCustomType(true);
    } else {
      setSelectedTypeName(selectedType);
    }
  };

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  const splitUserDisplayName = () => {
    const nameArray = props.caseDetails.display_name.split(",");
    if (nameArray.length === 1) {
      setFirstName(nameArray[0]);
    } else if (nameArray.length >= 1) {
      setFirstName(nameArray[0]);
    }
  };

  const displayPatientAlert = () => {
    setShowModalAlert(true);
    getTypesList();
  };

  const hidePatientAlert = () => {
    setShowModalAlert(false);
    props.showAlert();
  };

  const checkOtherCaseTypeSelected = (caseTypeList: any) => {
    setSelectedTypeName(props.caseDetails?.otherCaseTypeName);
  };

  const submitForm = (formData: any) => {
    let validationStatus = true;
    if (firstName === "") {
      Toast.error("Please enter first name to continue");
      validationStatus = false;
    }
    if (validationStatus) {
      let params = setParams(formData);
      updateCasePatient(params);
      hidePatientAlert();
    }
  };

  const getPatientDetails = async () => {
    setFetchedPatientData(props.fetchedcaseHistoryData);
  };

  useEffect(() => {
    if (props.caseDetails?.id) {
      getPatientDetails();
    }
  }, []);

  const updateMRN = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      mr_number: MRN,
      user_guid: utilService.getLoggedUserGuid(),
      patient_guid: props.listData.patient_guid,
    };
    addMRN(addParams);
  };

  const setParams = ({ fetchedResultData, formData, otherCaseType }: any) => {
    const params = {
      patient_name: `${formData?.firstName} ${formData?.middleName} ${formData?.lastName}`,
      reg_code: `${utilService.getNetwork()}`,
      gender: formData?.gender[0] ?? "",
      dob: formData?.dob ?? "",
      is_ems: checkEMS(),
      mr_number: formData?.mrn ?? "",
      caseHistoryId: props.caseDetails.id,
      ems_network_code: props.caseDetails.emsNetworkCode,
      site_guid: props.caseDetails.site_guid,
      case_type_list: selectedCaseTypeList,
      case_type_name: selectedProvidersNames,
      ehr_id: fetchedResultData?.ehr_id ?? "",
      first_name: formData?.firstName ?? "",
      last_name: formData?.lastName ?? "",
      middle_name: formData?.middleName ?? "",
      site_id: props?.fetchedcaseHistoryData?.site_id,
      bed_id: props?.fetchedcaseHistoryData?.bed_id,
      unit_id: props?.fetchedcaseHistoryData?.unit_id,
      display_name: formData?.firstName ?? "",
      dnr: fetchedResultData?.dnr ?? "",
      email_addresses: fetchedResultData?.email_addresses ?? "",
      phone_number: fetchedResultData?.phone_number ?? {},
      demographic: fetchedResultData?.demographic ?? {},
      ehr_bed_id: fetchedResultData?.ehr_bed_id ?? "",
      ehr_bed_name: fetchedResultData?.ehr_bed_name ?? "",
      ehr_unit_id: fetchedResultData?.ehr_unit_id ?? "",
      ehr_unit_name: fetchedResultData?.ehr_unit_name ?? "",
      primary_ehr_site_id: fetchedResultData?.primary_ehr_site_id ?? "",
      primary_ehr_site_name: fetchedResultData?.primary_ehr_site_name ?? "",
      profile_id:fetchedResultData?.profile_id ?? "",
      record_id:fetchedResultData?.record_id ?? "",
      other_case_type:otherCaseType,
    };

    return params;
  };

  async function addMRN(addParams: any) {
    const respTransferPatientResult: any = await notesContainerService.addMRN(
      addParams
    );
    if (respTransferPatientResult.isSuccess) {
      // Toast.success(CONSTANTS.MESSAGES.MRN);
    } else {
      notesContainerService.handleErrorResponse();
    }
  }

  async function updateCasePatient(formData: any) {
    const addCasePatientResult: any =
      await CaseHistoryService.updateCasePatient(formData);
    if (addCasePatientResult.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.UPDATED_FAVORITE_SUCCESS);
      props.updateCaseDetailsPage(props.caseDetails.id);
    } else {
      Toast.error(addCasePatientResult.message);
    }
  }

  const checkEMS = () => {
    if (isEMTUser) {
      return true;
    } else {
      return false;
    }
  };

  const getSelectedProvidersList = (CaseListArrayList: any) => {
    let caseTypeIds = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.id;
      }
    });

    let caseTypeNames = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.case;
      }
    });

    let caseLists = caseTypeIds.filter(function (element: any) {
      return element !== undefined;
    });

    let caseNameLists = caseTypeNames.filter(function (element: any) {
      return element !== undefined;
    });

    setSelectedCaseTypeList(caseLists);
    checkOtherCaseTypeSelected(caseLists);
    setSelectedProvidersNames(caseNameLists);
  };


  const handleEPICFormSave = (formData: any) => {
    submitForm(formData);
    // updateMRN();
  };

  useEffect(()=>{
    if(props.listData.patientCaseTypes?.length!==0){
      setCaseTypes(props?.listData?.patientCaseTypes?.map((caseType:any)=>{
        if(caseType.type==="Other"){
          return {
            ...caseType,
            case:"Other"
          }
        }else{
          return caseType
        }
      }))
    }
  },[props.listData.patientCaseTypes])



  return (
    <>
      <EpicPatientDetailsForm
        handleSaveButton={handleEPICFormSave}
        isOpen={showModalAlert}
        onCancel={hidePatientAlert}
        title={"Edit patient case details"}
        getSelectedProvidersList={getSelectedProvidersList}
        patientCaseTypes={caseTypes}
        selectedProvidersNames={selectedProvidersNames}
        isSelectCaseType={true}
        rowData={fetchedPatientData}
        isEMTUser={isEMTUser}
      />
    </>
  );
};

export default CaseHistoryDetailsEditMedia;
